import React from 'react';
import { connect } from 'react-redux';
import EditTrackerForm from './TrackingDefinitionEditCustomForm';
import { Edit, showNotification, withDataProvider } from 'react-admin';
import { handleAPIErrors } from '../../utils';
import LoadingIndicator from '../../components/LoadingIndicator';
import ConfirmationModal from '../../components/ConfirmationModal';

export const copyObject = (objectToCopy) => {
  return JSON.parse(JSON.stringify(objectToCopy));
};

export const isTrackingDefinitionResourceLoaded = (state) => {
  return state['cookieName'] !== '' && state['cookieDomain'] !== '' &&
    typeof state.dataProcessor.id !== 'undefined' && state.trackingDescription !== null;
};

export const updateDataProcessorWithTranslatedSpecification = (filteredDataProcessorsDescriptions, state) => {
  let dataProcessorChosenDescription = filteredDataProcessorsDescriptions.length > 0 ? filteredDataProcessorsDescriptions
    .find(el => el.language === state.trackingDescription.language) : {};

  let dataProcessor = copyObject(state.dataProcessor);
  dataProcessor.serviceSpecification = dataProcessorChosenDescription;

  return dataProcessor;
};

export const setupDataProcessorDescriptionsPayload = (dataProcessor, descriptions, account) => {
  let dataProcessorDescriptionsResult = descriptions.slice();
  dataProcessorDescriptionsResult = dataProcessorDescriptionsResult.map((description) => {
    if (dataProcessor.serviceSpecification && dataProcessor.serviceSpecification.id === description.id) {
      return dataProcessor.serviceSpecification;
    } else {
      return description;
    }
  });

  if (account == null) {
    dataProcessorDescriptionsResult.forEach(description => {
      delete description['@id'];
      delete description['@type'];
      delete description['id'];
      delete description['originId'];
    });
  }

  return dataProcessorDescriptionsResult;
};

export const setDataProcessorId = (dataProcessor) => {
  if (typeof dataProcessor.id === 'undefined') {
    return '';
  }

  return dataProcessor.id.replace('/data_processors/', '');
};

export const constructDataProcessorPayload = (dataProcessorToMap, state) => {
  let dataProcessorResult = {};

  if (state.dataProcessor.account !== null) {
    dataProcessorResult.id = setDataProcessorId(state.dataProcessor);
    dataProcessorResult['@id'] = state.dataProcessor['@id'];
    dataProcessorResult['@type'] = state.dataProcessor['@type'];
  }

  dataProcessorResult.name = dataProcessorToMap.name;
  dataProcessorResult.privacyPolicy = dataProcessorToMap.privacyPolicy;
  dataProcessorResult.descriptions =
    setupDataProcessorDescriptionsPayload(dataProcessorToMap, state.dataProcessorDescriptions,
      state.dataProcessor.account);

  dataProcessorResult.account = state.account;
  dataProcessorResult.serviceRole = dataProcessorToMap.serviceRole;

  return dataProcessorResult;
};

export const constructCookieDescriptionsPayload = (trackingDescriptionToMap, state) => {
  let cookieDescriptionsResult = state.cookieDescriptions.slice();

  return cookieDescriptionsResult.map((description) => {
    if (trackingDescriptionToMap.id === description.id) {
      return trackingDescriptionToMap;
    } else {
      return description;
    }
  });
};

export const buildUpdatePayload = (formValues, state) => {
  let payload = {};

  payload.category = formValues.category;
  payload.website = state.website;
  payload.dataProcessor = constructDataProcessorPayload(formValues.dataProcessor, state);
  payload.descriptions = constructCookieDescriptionsPayload(formValues.trackingDescription, state);

  return payload;
};

export const setupTrackingCategories = (categories) => {
  return categories.map(singleCategory => {
    return {id: singleCategory.id, name: singleCategory.visibleName};
  });
};

class TrackingDefinitionsEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cookieName: '',
      cookieDomain: '',
      dataProcessor: {},
      dataProcessorDescriptions: [],
      cookieDescriptions: [],
      languages: [],
      chosenLanguage: {},
      trackingDescription: null,
      website: '',
      account: null,
      showDialog: false,
      trackingCategories: [],
    };
    ({dataProvider: this.dataProvider} = this.props);
  }

  componentDidMount() {
    this.loadTrackingDefinitionResource();
  }

  async loadTrackingDefinitionResource() {
    this.dataProvider.getOne('tracking_definitions', {id: this.props.id})
      .then(trackingDefinition => {
        this.setState({...trackingDefinition.data});

        return this.dataProvider.getMany('tracking_descriptions', {ids: trackingDefinition.data.descriptions});
      })
      .then((trackingDescriptions) => {
        this.setState({
          cookieDescriptions: trackingDescriptions.data,
          trackingDescription: trackingDescriptions.data[0] || {},
        });

        return this.dataProvider.getOne('data_processors', {id: this.state.dataProcessor});
      })
      .then((dataProcessor) => {
        this.setState({dataProcessor: dataProcessor.data});

        const dataProcessorDescriptionsIds = [...this.state.dataProcessor.descriptions];
        return this.dataProvider.getMany('data_processor_descriptions', {ids: dataProcessorDescriptionsIds});
      })
      .then((dataProcessorsDescriptions) => {
        const dataProcessor = updateDataProcessorWithTranslatedSpecification(dataProcessorsDescriptions.data, this.state);

        this.setState({dataProcessorDescriptions: dataProcessorsDescriptions.data, dataProcessor: dataProcessor});
        let languagesIds = this.state.cookieDescriptions.map(description => description.language);

        return this.dataProvider.getMany('languages', {ids: languagesIds});
      })
      .then((languages) => {
        const chosenLanguage = languages.data.find(lang => lang.id === this.state.trackingDescription.language);
        this.setState({languages: languages.data, chosenLanguage: chosenLanguage});

        return this.dataProvider.getOne('websites', {id: this.state.website});
      })
      .then((website) => {
        this.setState({account: website.data.account});

        return this.dataProvider.getList('tracking_categories', {
          pagination: {
            page: 1,
          },
          sort: {
            field: 'visibleName',
            order: 'DESC',
          },
          filter: {
            itemsPerPage: 100,
            website: website.data.id,
          },
        });
      })
      .then(trackingCategories => {
        const categories = setupTrackingCategories(trackingCategories.data);

        this.setState({trackingCategories: categories});
      })
      .catch(error => {
        handleAPIErrors(error, this.props.history);
        console.error(error);
      });
  }

  chooseLanguage(language) {
    let cookieDescription = this.state.cookieDescriptions.find(el => el.language === language.id);

    if (cookieDescription) {
      this.setState({trackingDescription: cookieDescription});
    }

    this.setState({chosenLanguage: language});
  }

  handleSubmit(formData) {
    this.setState({formData, showDialog: true});
  }

  async saveTracker() {
    const {formData} = this.state;
    const payload = buildUpdatePayload(formData, this.state);
    this.dataProvider.update('tracking_definitions', {
      id: this.state.id,
      data: payload,
    })
      .then((response) => {
        this.props.showNotification('Tracking definition updated successfully !');
      })
      .catch(error => {
        handleAPIErrors(error, this.props.history);
      })
      .finally(() => {
        this.loadTrackingDefinitionResource();
        this.closeDialogPrompt();
      });
  };

  closeDialogPrompt() {
    this.setState({
      showDialog: false,
    });
  }

  render() {
    const initialValues = {
      cookieName: this.state.cookieName,
      cookieDomain: this.state.cookieDomain,
      category: this.state.category,
      dataProcessor: this.state.dataProcessor,
      trackingDescription: this.state.trackingDescription,
    };

    const stepProps = {
      onLanguageChange: language => this.chooseLanguage(language),
      languages: this.state.languages,
      chosenLanguage: (this.state.chosenLanguage || {}).id,
      history: this.props.history,
      trackingCategories: this.state.trackingCategories,
    };

    const {dataProvider, ...rest} = this.props;

    return (<div>
        {
          isTrackingDefinitionResourceLoaded(this.state) ?
            <Edit {...rest} toolbar={null} actions={null}>
              <EditTrackerForm initialValues={initialValues} toolbar={null}
                               onSubmit={(data) => this.handleSubmit(data)} enableReinitialize="true" {...stepProps} />
            </Edit> : <LoadingIndicator/>
        }
        <ConfirmationModal
          open={this.state.showDialog}
          title="Are you sure you want to save and publish changes?"
          message="The changes will be visible after 10 minutes and will overwrite this cookie in cookie policy on your website."
          okText="SAVE"
          cancelText="CANCEL"
          onOk={() => this.saveTracker()}
          onCancel={() => this.closeDialogPrompt()}
        />
      </div>
    );
  }
}

export default connect(null, {
  showNotification,
})(withDataProvider(TrackingDefinitionsEdit));
